import { render } from "./PasswordSettings.vue?vue&type=template&id=30e6b29e"
import script from "./PasswordSettings.vue?vue&type=script&lang=js"
export * from "./PasswordSettings.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__